import { useTranslation } from 'react-i18next';

import { APPLICABLE_MODEL_YEARS, APPLICABLE_MODELS } from '../ssm5.constants';
import { ApplicableModelsTable } from './applicable-models-table';
import { Ssm5Modal } from './ssm5-modal';

/** Props for {@link ApplicableModelsModal}. */
export type ApplicableModelsModalProps = {
    /** Called when the modal wants to close. */
    onHide: () => void;
    /** Whether the modal is visible. */
    show: boolean;
};

const MODAL_WIDTH = 800;

/**
 * Modal listing the carlines and model years that support the SSM5 diagnostic.
 *
 * @param props - {@link ApplicableModelsModalProps}
 * @returns the modal
 */
export function ApplicableModelsModal({ onHide, show }: ApplicableModelsModalProps) {
    const { t } = useTranslation();

    return (
        <Ssm5Modal
            closeLabel={t('ssm5:applicableModels.close')}
            onHide={onHide}
            show={show}
            title={t('ssm5:applicableModels.title')}
            width={MODAL_WIDTH}
        >
            <ApplicableModelsTable models={APPLICABLE_MODELS} modelYears={APPLICABLE_MODEL_YEARS} />
        </Ssm5Modal>
    );
}
